import { h, Host } from "@stencil/core";
import { tokenMap } from "../../../../common/utils";
import { TABULAR_GRID_PARTS_DICTIONARY } from "../../../../common/reserved-names";
/**
 * The `ch-tabular-grid-rowset-legend` component represents a caption for the `ch-tabular-grid-rowset` element.
 */
export class ChTabularGridRowsetLegend {
    constructor() {
        this.parts = undefined;
    }
    el;
    /**
     * Event emitted when the legend is clicked.
     */
    rowsetLegendClicked;
    clickHandler() {
        this.rowsetLegendClicked.emit();
    }
    #getRowsetId = () => {
        const rowset = this.el.parentElement;
        return rowset?.rowsetId;
    };
    render() {
        return (h(Host, { key: '4603d3c3926f134391847dd8d2bb951dfef94586', part: this.parts
                ? tokenMap({
                    [TABULAR_GRID_PARTS_DICTIONARY.ROWSET_LEGEND]: true,
                    [this.#getRowsetId()]: !!this.#getRowsetId(),
                    [this.parts.toString()]: typeof this.parts === "string"
                })
                : null }, h("div", { key: '9c832463b6a8582a28f1e328ad064bf0110f38a7', part: "caret" }), h("label", { key: '421196c5acbf002b4b434d5c8d9b3e0704490a05', part: "selector-label" }, h("input", { key: 'e562f508e7f9f4e040853735f1604ca942cb69df', type: "checkbox", part: "selector" })), h("div", { key: 'aadcea8ced93cf05e523c6320f175b3469016d44', part: "icon" }), h("slot", { key: 'ade85f6b6254e8e25e37c8375ebdf364f9bc7543' })));
    }
    static get is() { return "ch-tabular-grid-rowset-legend"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["tabular-grid-rowset-legend.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["tabular-grid-rowset-legend.css"]
        };
    }
    static get properties() {
        return {
            "parts": {
                "type": "any",
                "mutable": false,
                "complexType": {
                    "original": "boolean | string",
                    "resolved": "boolean | string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "A boolean or string that controls the parts applied to the legend.\n- When `true`, it automatically applies the part names \"column\" and the column's unique ID.\n- When a string is provided, it appends that string to the default part names \"column\" and the column's ID."
                },
                "attribute": "parts",
                "reflect": false
            }
        };
    }
    static get events() {
        return [{
                "method": "rowsetLegendClicked",
                "name": "rowsetLegendClicked",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Event emitted when the legend is clicked."
                },
                "complexType": {
                    "original": "CustomEvent",
                    "resolved": "CustomEvent<any>",
                    "references": {
                        "CustomEvent": {
                            "location": "global",
                            "id": "global::CustomEvent"
                        }
                    }
                }
            }];
    }
    static get elementRef() { return "el"; }
    static get listeners() {
        return [{
                "name": "click",
                "method": "clickHandler",
                "target": undefined,
                "capture": false,
                "passive": true
            }];
    }
}
